module.exports = __webpack_public_path__ + "img/default_avator.f1ec507b.png";